var _style, _g, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIqonGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.15;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{opacity:0.4;}\n\t.st5{clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st6{clip-path:url(#SVGID_4_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "globe",
    d: "M21.2,15.8c0.5-1.2,0.8-2.5,0.8-3.8s-0.3-2.6-0.8-3.8V8h-0.1c-1.5-3.5-5.1-6-9.2-6C6.5,2,2,6.5,2,12 c0,5.5,4.5,10,10,10c4.1,0,7.6-2.5,9.2-6h0.1V15.8z M12,20c-0.8,0-1.9-1.5-2.6-4h5.1C13.9,18.5,12.8,20,12,20z M9.1,14 C9,13.4,9,12.7,9,12c0-0.7,0-1.4,0.1-2h5.8c0.1,0.6,0.1,1.3,0.1,2c0,0.7,0,1.4-0.1,2H9.1z M4,12c0-0.7,0.1-1.4,0.3-2h2.8 C7,10.6,7,11.3,7,12s0,1.4,0.1,2H4.3C4.1,13.4,4,12.7,4,12z M12,4c0.8,0,1.9,1.5,2.6,4H9.4C10.1,5.5,11.2,4,12,4z M16.9,10h2.8 c0.2,0.6,0.3,1.3,0.3,2s-0.1,1.4-0.3,2h-2.8c0.1-0.6,0.1-1.3,0.1-2S17,10.6,16.9,10z M18.9,8h-2.3c-0.2-1.2-0.6-2.3-1.1-3.2 C17,5.5,18.1,6.6,18.9,8z M8.4,4.8C8,5.7,7.6,6.8,7.4,8H5.1C5.9,6.6,7,5.5,8.4,4.8z M5.1,16h2.3c0.2,1.2,0.6,2.3,1.1,3.2 C7,18.5,5.9,17.4,5.1,16z M15.6,19.2c0.4-0.9,0.8-2,1.1-3.2h2.3C18.1,17.4,17,18.5,15.6,19.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "border"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "keylines"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqonGlobe);
export default __webpack_public_path__ + "static/media/iqon_globe.d717398e.svg";
export { ForwardRef as ReactComponent };